import React from 'react'

export default function NPOSAccountHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .tab-button-container {
          display: flex;
        }
        .hide-tbc { display: none; }

        .tab-button {
          font-weight: bold;
          padding: 15px;
          background-color: transparent;
          border: none;
          border-radius: 0;
        }
        .tab-button:hover {
          background-color: rgba(200, 200, 255, 0.2);
          color: black;
        }
        .tab-button:focus {
          background-color: darkgrey;
          color: white;
          outline: none;
        }
        .active-tab {
          background-color: darkgrey;
          color: white;
        }
      `}
      </style>
    </React.Fragment>
  )
}
